export default __webpack_public_path__ + "static/media/woman.f128f2f0.svg";